module.exports = __webpack_public_path__ + "img/imba.edc05e7d.svg";